(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  function initGallery(g) {
    if (g.dataset.galleryReady) return;
    g.dataset.galleryReady = '1';

    var track = g.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = track.children.length;
    if (slides <= 1) return;

    var dots = Array.prototype.slice.call(g.querySelectorAll('.card-gallery__dot'));
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');

    if (prev) prev.hidden = false;
    if (next) next.hidden = false;

    function current() {
      var w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }
    function update() {
      var i = current();
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
      }
      if (prev) prev.style.visibility = i <= 0 ? 'hidden' : '';
      if (next) next.style.visibility = i >= slides - 1 ? 'hidden' : '';
    }
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function scrollToIndex(idx) {
      var w = track.clientWidth || 1;
      idx = Math.max(0, Math.min(slides - 1, idx));
      track.scrollTo({ left: idx * w, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function go(dir) { scrollToIndex(current() + dir); }

    // Tastatur-navigation (galleriet er eet tab-stop; pilene forbliver mus-only)
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'Home') { e.preventDefault(); scrollToIndex(0); }
      else if (e.key === 'End') { e.preventDefault(); scrollToIndex(slides - 1); }
    });

    // Desktop hover-zoner (AliExpress-stil): muspositionen styrer billedet, uden klik
    var hoverZones = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    if (hoverZones) {
      var hoverIdx = -1;
      g.addEventListener('mousemove', function (e) {
        var rect = track.getBoundingClientRect();
        var w = rect.width || 1;
        var idx = Math.floor((e.clientX - rect.left) / (w / slides));
        if (idx < 0) { idx = 0; } else if (idx > slides - 1) { idx = slides - 1; }
        if (idx === hoverIdx) return;
        hoverIdx = idx;
        track.scrollLeft = idx * track.clientWidth;
      });
      g.addEventListener('mouseleave', function () {
        hoverIdx = -1;
        track.scrollLeft = 0;
      });
    } else {
      // Ingen hover (touch-laptop, pen m.m.): mus-traek = swipe. Touch/pen bruger browserens egen scroll.
      var dragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; dragMoved = false;
        dragStartX = e.clientX; dragStartScroll = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - dragStartX;
        if (!dragMoved && Math.abs(dx) > 4) { dragMoved = true; track.classList.add('is-dragging'); }
        if (dragMoved) { e.preventDefault(); track.scrollLeft = dragStartScroll - dx; }
      });
      var endDrag = function () {
        if (!dragging) return;
        dragging = false;
        if (dragMoved) { track.classList.remove('is-dragging'); scrollToIndex(current()); }
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('mouseleave', endDrag);
    }

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });

    // Hindr at en drag (desktop-mus) foelger produkt-linket
    var downX = null;
    track.addEventListener('pointerdown', function (e) { downX = e.clientX; });
    track.addEventListener('click', function (e) {
      if (downX !== null && Math.abs(e.clientX - downX) > 8) {
        e.preventDefault();
        e.stopPropagation();
      }
      downX = null;
    }, true);

    update();
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('.js-card-gallery');
    for (var i = 0; i < list.length; i++) initGallery(list[i]);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  // Fang kort der indsaettes via AJAX (filtre, uendelig scroll, quick view)
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && n.matches('.js-card-gallery')) initGallery(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
